import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import displayNames from './displayNames';

var ImageAndTextTemplate = function ImageAndTextTemplate(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('image-and-text')
  }, props.image ? /*#__PURE__*/React.createElement("div", {
    key: "image",
    className: "image"
  }, props.image) : null, props.title || props.text ? /*#__PURE__*/React.createElement("div", {
    key: "content",
    className: "content"
  }, props.title ? /*#__PURE__*/React.createElement("h3", {
    key: "title",
    className: "title"
  }, props.translateIfNeeded(props.title)) : null, props.text ? /*#__PURE__*/React.createElement("div", {
    key: "text",
    className: "text"
  }, _.isString(props.text) ? props.translateIfNeeded(props.text) : props.text) : null) : null);
};

ImageAndTextTemplate.displayName = displayNames.IMAGE_AND_TEXT_TEMPLATE;
ImageAndTextTemplate.propTypes = {
  image: PropTypes.element,
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
export default compose(ImageAndTextTemplate);